var prefix = 'ak-editor-sync-block';
export var SyncBlockSharedCssClassName = {
  prefix: prefix,
  renderer: "".concat(prefix, "__renderer"),
  error: "".concat(prefix, "__error_state")
};
var bodiedPrefix = 'ak-editor-bodied-sync-block';
export var BodiedSyncBlockSharedCssClassName = {
  prefix: bodiedPrefix,
  content: "".concat(bodiedPrefix, "__content"),
  selectionInside: "".concat(bodiedPrefix, "__selection_inside")
};
var labelClassName = 'ak-editor-sync-block__label';
export var SyncBlockLabelSharedCssClassName = {
  labelClassName: labelClassName
};
export var disabledClassName = 'disabled';
export var viewModeClassName = 'view-mode';
export var SyncBlockStateCssClassName = {
  disabledClassName: disabledClassName,
  viewModeClassName: viewModeClassName
};